module.exports = __webpack_public_path__ + "214512232080af17059bdd35e798f877.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/PM.svg
// module id = /Htx
// module chunks = 0